/*
 * @Descripttion:
 * @version:
 * @Author: wanglikun
 * @Date: 2022-07-08 10:00:59
 * @LastEditors: sueRimn
 * @LastEditTime: 2022-11-01 14:46:03
 */
import { createApp } from 'vue'
import App from './App.vue'
import router from './router/index'
import store from '@jms/store/store'
import registerCompoent from '@jms/components'
import { lang } from '@jms/utils'
import request from '@jms/api/request'

const app = createApp(App)
const packageList = [router, store, registerCompoent]
packageList.forEach((p) => app.use(p))

// --- 样式引入区域 ---
import 'ant-design-vue/dist/antd.less'
import '@wtl/site-common/dist/es/index.css' // 如果确认用到
import '@tmp/site-common/dist/es/index.css' // 如果确认用到
import '@/assets/style/common.less'
// --- 样式引入区域 ---

app.config.globalProperties.$lang = lang
app.config.globalProperties.$req = request
app.mount('#app')
